import React from 'react';
import GCProvider from './global-context';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import ScrollToTop from './app/ScrollToTop';
import './index.css';
import routes from './routes';

const supportsHistory = 'pushState' in window.history;

function ServiceRequestApp() {
	return (
		<GCProvider>
			<BrowserRouter forceRefresh={!supportsHistory}>
				<ScrollToTop>
					{ routes() }
				</ScrollToTop>
			</BrowserRouter>
		</GCProvider>
	);
}

const rootElement = document.getElementById('root');
ReactDOM.render(<ServiceRequestApp />, rootElement);
